/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";
import MKInput from "components/MKInput";

// Material Kit 2 React components
import { Link } from "react-router-dom";

import MKPagination from "components/MKPagination";
import Icon from "@mui/material/Icon";


import React, { useState, useEffect } from "react";

import { getAlbumVids } from 'assets/customgraphql/queries';

import { useParams } from 'react-router-dom';
import { dynamicSort } from "assets/utils";
import TransparentVideoCard from "components/Cards/AlbumCards/TransparentVideoCard";
import VideoModal from "layouts/sections/attention-catchers/modals/components/VideoModal";
import { generateClient } from "aws-amplify/api";
import { getUrl, list } from "aws-amplify/storage";




function AlbumVidSection() {
  const { id, pagenum } = useParams();
  const [albumlist, updateAlbumList] = useState([]);
  const [albumlistpage, updateAlbumListPage] = useState([]);
  const [albumpages, updateAlbumPages] = useState([]);
  const [albumname, updateAlbumName] = useState([]);

  const [albumlistfiltered, updateAlbumListFiltered] = useState([]);
  const [albumlistfilterquery, updateAlbumListFilterquery] = useState([]);

  const [numpages, updateNumPages] = useState([]);
  const [pagelist, updatePageList] = useState([]);

  const [selectedPostIndex, updateSelectedPostIndex] = useState(null);
  const handlePostClick = (postIndex => {
    console.log("handlePostClick triggered: ", postIndex);
    updateSelectedPostIndex(parseInt(postIndex))
  });
  const handleCloseImageModal = () => { updateSelectedPostIndex(null) };

  const handleNext = () => {
    updateSelectedPostIndex((prevIndex) => (prevIndex + 1));
  }

  const handlePrev = () => {
    updateSelectedPostIndex((prevIndex) => (prevIndex - 1));
  }

  
  const itemsPerPage = 40;
  useEffect(() => {
    fetchAlbum(id);
  }, [id]);
  
  useEffect(() => {
    renderAlbumPage(pagenum);
  }, [pagenum, albumlistfiltered, numpages])
  
  //  Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [id, pagenum]);
  
  
  async function fetchAlbum(id) {
    const APIClient = generateClient();
    let albumData = await APIClient.graphql({ query: getAlbumVids, variables: { id } });
    let albumsArray = albumData.data.getAlbum.videos.items;
    // console.log(albumData);
    //console.log(albumsArray);
    updateAlbumName(albumData.data.getAlbum.name);
    albumsArray.sort(dynamicSort("createdAt"));
    
    updateAlbumList(albumsArray);
    updateAlbumListFiltered(albumsArray);
  }
  
  const handleChange = (e) => {
    updateAlbumListFilterquery(e.target.value)
    filterAlbum(e.target.value)
  }
  
  function filterAlbum(filterstring) {
    //grab the full list (albumlist)
    //check the filter string is not blank
    if (filterstring === "") {
      updateAlbumListFiltered(albumlist);
      return;
    }
    //iterate through it to find matches
    const results = albumlist.filter(image => {
      if (!image.plates) return
      return String(image.plates).includes(filterstring)
    })
    //add the matches to a new array
    //export the arry to the filteredlist
    updateAlbumListFiltered(results);

  }



  async function renderAlbumPage(pagenum) {
    updateNumPages(Math.ceil(albumlistfiltered.length / itemsPerPage));
    updateAlbumPages()
    // console.log("Start renderAlbumPage");
    // console.log("Number pages: " + numpages);
    // console.log("This page: " + pagenum)
    // Now need to loop through the albumlist object, and select only the items for this page (albumlistpage)
    let pagearray = albumlistfiltered.slice((pagenum - 1) * itemsPerPage, pagenum * itemsPerPage);
    // console.log(pagearray);


    let promisearray = [];
    console.log(pagearray);

    const publicProcessedPrefix = "public/processed/video/"

    // This should give us a thumbnail from the video - let's call it image.thumbnail from the appsync object. If not exists let's just use nothing for now.


    await pagearray.map((image) => {
      // let promise = Storage.get("processed/tn-" + image.image).then(result => { image.imageurl = result });
      // promisearray.push(promise);
      // let dlpromise = Storage.get("processed/wm-" + image.image).then(result => { image.dlurl = result });
      // promisearray.push(dlpromise);
      // let vidpromise = Storage.get(publicProcessedPrefix + image.id + "/" + image.filename).then(result => { image.vidurl = result });
      // promisearray.push(vidpromise);
      let vidlistpromise = list({path: publicProcessedPrefix + image.id + "/"}).then(result => {
        //console.log(result)
        image.vidlist = [];
        image.tnlist = [];
        for (const listItem of result.items)  {
          if (listItem.path.endsWith(".mp4")) {
            getUrl({path: listItem.path}).then(result => {
              image.vidlist.unshift({
                src: result.url.href,
                type: "video/mp4",
              });
            })
        }
        if (listItem.path.endsWith(".jpg")) {
          getUrl({path: listItem.path}).then(result => {
            image.tnlist.push(result.url.href);
          })
      }
        }
      });
      promisearray.push(vidlistpromise);
    }
    )
    Promise.all(promisearray).then((values) => {
      // console.log("All promises returned, running updateAlbumListPage");
      updateAlbumListPage(pagearray);
      console.log(pagearray)
    }
    )
    let pageswidth = 5;
    let pagesperside = (Math.floor(pageswidth / 2));
    let pagesmin = pagenum - pagesperside;
    let pagesmax = +pagenum + pagesperside;

    var pagelistarr = []
    for (var i = 0; i < numpages; i++) {
      // console.log("ForLoop, i = " + i);
      var obj = { "pagenum": (i + 1), "active": (i + 1 === pagenum) };
      //console.log(obj);
      // console.log(pagesmin);
      // console.log(pagenum);
      // console.log(pagesmax);
      if ((i + 1 >= pagesmin) & (i + 1 <= pagesmax)) {
        pagelistarr.push(obj)
      };
    }
    // console.log("PageListArr: ");
    // console.log(pagelistarr);
    updatePageList(pagelistarr);
  }




  return (
    <MKBox component="section" py={0} >
      <VideoModal show={selectedPostIndex !== null} albumlistpage={albumlistpage} albumname={albumname} selectedpostindex={parseInt(selectedPostIndex)} onClose={handleCloseImageModal} onPrev={handlePrev} onNext={handleNext} />
      <Container>
        <Grid container item >
          <MKTypography variant="h3" mb={1} mt={1}>
            {albumname}
          </MKTypography>
        </Grid>
        {/* {(parseInt(pagenum, 10) === 1) && <Grid container item mb={1}><MKInput variant="outlined" label="Plate search" onChange={handleChange} /></Grid>} */}
        <Grid container spacing={3}>

          {albumlistpage.map((item, itemIndex) => (
            <Grid item xs={6} lg={3} key={item.id} onClick={() => handlePostClick(itemIndex)}>
              {/* <VideoJS options={{ ...videoJsOptions, sources: [...item.vidlist] }} onReady={handlePlayerReady} /> */}
              <TransparentVideoCard image={item.tnlist[0]} title={item.title}/>
              {/* <ImageModal postinfo={item}> </ImageModal> */}
            </Grid>


          ))}

        </Grid>
      </Container>
      <Container >
        <MKPagination placement="center" key="paginationSection">
          {(parseInt(pagenum, 10) > 1) && <Link to={"page/" + (parseInt(pagenum, 10) - 1)}><MKPagination key="pageless" item><Icon>keyboard_arrow_left</Icon></MKPagination></Link>}
          {pagelist.map((item) => (
            <Link to={"page/" + item.pagenum} key={"link" + item.pagenum}><MKPagination item active={item.active} key={"page" + item.pagenum}>{item.pagenum}</MKPagination></Link>
          ))}

          {/* list of pages here */}


          {(parseInt(pagenum, 10) < parseInt(numpages, 10)) && <Link to={"page/" + (parseInt(pagenum, 10) + 1)}><MKPagination key="pagemore" item><Icon>keyboard_arrow_right</Icon></MKPagination></Link>}
        </MKPagination>
      </Container>
    </MKBox>
  );
}

export default AlbumVidSection;
